const gridView = document.querySelectorAll('.grid-view span:not(.divider-char)');
const productGrid = document.querySelector('#product-grid');

function debounce(func, wait) {
  let timeout;
  return function executedFunction() {
    const context = this;
    const args = arguments;
        
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

const reinitSplideSliders = () => {
  document.querySelectorAll('.splide').forEach(splideEl => {
    let splideInstance = new Splide(splideEl).mount();
    splideEl.splideInstance = splideInstance;
  });
};

const refreshSliders = () => {
  document.querySelectorAll('.splide').forEach(splideEl => {
    if (splideEl.splideInstance) {
      splideEl.splideInstance.refresh();
    }
  });
  //reinitSplideSliders();
  document.querySelectorAll('.splide').forEach(splideEl => {
    if (splideEl.splideInstance) {
      splideEl.splideInstance.go(0);
    }
  });
};

// debounce refreshSliders so it doesn't run too often
const debouncedRefreshSliders = debounce(refreshSliders, 100);


if (gridView) {
  gridView.forEach((el) => {
    el.addEventListener('click', () => {
      gridView.forEach((el) => el.classList.remove('active'));
      el.classList.add('active');
      productGrid.dataset.view = el.dataset.gridView;
        reinitSplideSliders();
        document.querySelectorAll('.splide').forEach(splideEl => {
          if (splideEl.splideInstance) {
            splideEl.splideInstance.go(0);
          }
        });
    });
  });
}

const targetNode = document.querySelector('#CartDrawer'); 
const config = { attributes: true, childList: true, subtree: true };

const observer = new MutationObserver(function(mutationsList, observer) {
  debouncedRefreshSliders();
});

if (targetNode) {
    observer.observe(targetNode, config);
}

const resizeObserver = new ResizeObserver(entries => {
  debouncedRefreshSliders();
});
resizeObserver.observe(document.body);
window.addEventListener('resize', () => {
  debouncedRefreshSliders();
});


// on page load
debouncedRefreshSliders();